import { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';

/**
 * Counts up to the number inside `value` when scrolled into view, keeping any
 * prefix/suffix text ("650+", "3 lakh+", "2013"). Years are shown as-is.
 */
export default function CountUp({ value = '', duration = 1.6, className }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-40px' });
  const reduce = useReducedMotion();
  const match = String(value).match(/^(\D*)([\d,]+)(.*)$/);
  const target = match ? Number(match[2].replace(/,/g, '')) : null;
  const isYear = target && target >= 1900 && target <= 2100 && !match[3];
  const [shown, setShown] = useState(target === null || isYear || reduce ? value : `${match[1]}0${match[3]}`);

  useEffect(() => {
    if (!inView || target === null || isYear || reduce) {
      setShown(value);
      return undefined;
    }
    const controls = animate(0, target, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setShown(`${match[1]}${Math.round(v).toLocaleString('en-IN')}${match[3]}`),
    });
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, value]);

  return (
    <span ref={ref} className={className} aria-label={value}>
      <span aria-hidden="true">{shown}</span>
    </span>
  );
}
